module.exports = __webpack_public_path__ + "newsdefault1.jpg?3d0da0fd3b74c6ddb4aba956be47b207";